import { Suspense } from 'react';
import type { ComponentType } from 'react';
import { useCurrentAccount } from '@alliance-disposal/client';
import type { FeatureFlag } from '@alliance-disposal/client';
import PageLoader from '../../components/PageLoader/PageLoader';

interface FeatureFlagRouteSwitchProps {
    requiredFeatureFlag: FeatureFlag;
    /** Rendered when the feature flag is enabled */
    EnabledComponent: ComponentType;
    /** Rendered when the feature flag is disabled */
    FallbackComponent: ComponentType;
}

/**
 * Renders one of two components for the same route path depending on whether a feature flag is enabled.
 * Used to transparently route legacy paths to their new equivalents during a phased migration.
 */
const FeatureFlagRouteSwitch = ({ requiredFeatureFlag, EnabledComponent, FallbackComponent }: FeatureFlagRouteSwitchProps) => {
    const { featureFlags } = useCurrentAccount();
    const Component = featureFlags.includes(requiredFeatureFlag) ? EnabledComponent : FallbackComponent;

    return (
        <Suspense fallback={<PageLoader />}>
            <Component />
        </Suspense>
    );
};

export default FeatureFlagRouteSwitch;
